import React from 'react';
function Link({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.6 12.887c.302.414.687.757 1.13 1.005a3.451 3.451 0 002.915.214c.473-.18.902-.464 1.258-.83l2.11-2.164c.64-.68.995-1.59.987-2.537a3.653 3.653 0 00-1.03-2.519A3.473 3.473 0 0015.514 5a3.47 3.47 0 00-2.473 1.012l-1.21 1.234"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.4 11.113a3.542 3.542 0 00-1.13-1.005 3.45 3.45 0 00-2.915-.214c-.472.18-.901.464-1.258.83l-2.11 2.164A3.657 3.657 0 005 15.425c.008.945.378 1.85 1.03 2.519A3.474 3.474 0 008.486 19a3.47 3.47 0 002.473-1.012l1.203-1.234"
      />
    </svg>
  );
}

export default Link;
